import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';
import ContactForm from '../components/ContactForm';
import groupinfo from '../data/groupinfo.json';
import OnPageLoaded from '../utils/onpageloaded';
//import WOW from 'wowjs';

import '../css/contacts.css';

class Contacts extends Component {
    componentDidMount() {
        document.title = "Damatrà - Contatti";
        const description="Cell: +39 340 30 87 943 (Roberto) - mail: info@damatrafolk.it. Siamo a tua disposizione per qualsiasi informazione riguardante la nostra musica, i nostri concerti e la nostra attività.";
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        OnPageLoaded(true, true);
    }

    render() {
        return (
            <div>
                <PageTitle title="Contatti" bgimgurl="/img/titlebg/contatti.jpg"></PageTitle>
                <div className="container">
                    <div className="row text-center mb-5">
                        <div className="col-12 col-sm-6 col-md-3">
                            <a className="btn-floating primary-bkg" href={"tel:" + groupinfo.phone}>
                                <i className="fas fa-phone btn-floating-icon"></i>
                            </a>
                            <p className="font-roboto mb-1">{groupinfo.phone} <i>{groupinfo.contact_name}</i></p>
                            <p className="font-roboto mt-0">+39 346 72 99 349 <i>Marco</i></p>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3">
                            <a className="btn-floating primary-bkg" href={"mailto:" + groupinfo.email}>
                                <i className="fas fa-envelope btn-floating-icon"></i>
                            </a>
                            <p>{groupinfo.email}</p>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3">
                            <a className="btn-floating primary-bkg" target="_blank" href={"http://maps.google.com/maps?q=" + encodeURIComponent(groupinfo.location.city)}>
                                <i className="fas fa-map btn-floating-icon" title="Visualizza sulla mappa di Google"></i>
                            </a>
                            <p>{groupinfo.location.city}</p>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3">
                            <a className="btn-floating accent-bkg btn-fb" href={groupinfo.fbpageurl} target="_blank">
                                <i className="fab fa-facebook-f btn-floating-icon"></i>
                            </a>
                            <p>Pagina Fb Damatrà</p>
                        </div>
                    </div>
                    <div className="row" style={{display:"none"}}>
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header white-text accent-bkg">
                                    Modulo di contatto
                                    </div>
                                <div className="card-body">
                                    <ContactForm apiurl="grrass"></ContactForm>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contacts;


// WEBPACK FOOTER //
// ./src/pages/Contacts.js